import { BuscarAnexosVendaConsignatarioModel } from "../models/vendaConsignatario/buscarAnexosVendaConsignatarioModel";
import { BuscarVendaConsignatarioModel } from "../models/vendaConsignatario/buscarVendaConsignatarioModel";
import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const buscarVendaConsignatario = createAsyncThunk("/VendaConsignatario/BuscarVendaConsignatario", async (args: BuscarVendaConsignatarioModel) => {
  try {
    const data = await api.get("/VendaConsignatario/BuscarVendaConsignatario", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarAnexosVendaConsignatario = createAsyncThunk("/VendaConsignatario/BuscarAnexosVendaConsignatario", async (args: BuscarAnexosVendaConsignatarioModel) => {
  try {
    const data = await api.get("/VendaConsignatario/BuscarAnexosVendaConsignatario", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
